import React, { useMemo, useEffect } from "react";
import DashboardLayout from "@/src/components/layout/DashboardLayout";
import Script from "next/script";
import Header from "@/src/modules/pet-ct-appointment-new/header";
import SelectAppointment from "@/src/modules/pet-ct-appointment-new/select-appointment/SelectAppointment";
import { useSelector, useDispatch } from "react-redux";
import {
    appointmentSteps,
    resetAppointment,
} from "@/src/lib/store/pet-ct-appointment-new/slice";
import SelectCentre from "@/src/modules/pet-ct-appointment-new/select-centre/SelectCentre";
import DateTime from "@/src/modules/pet-ct-appointment-new/date-time";
import SelectPatient from "@/src/modules/pet-ct-appointment-new/select-patient/SelectPatient";
import PaymentConfirmation from "@/src/modules/pet-ct-appointment-new/payment-confirmation/index";

PetCtAppointmentNew.getLayout = (page) => (
    <DashboardLayout>{page}</DashboardLayout>
);
const facilityBannerImageResponsive =
    "category-banners-responsive/CT_df52bb64.webp";

function PetCtAppointmentNew() {
    const { currentStep } = useSelector((state) => state.appointmentNew);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(resetAppointment());
    }, []);

    const DynamicComponent = useMemo(() => {
        switch (currentStep) {
            case appointmentSteps.SELECT_APPOINTMENT:
                return <SelectAppointment />;
            case appointmentSteps.SELECT_CENTRE:
                return <SelectCentre />;
            case appointmentSteps.SELECT_DATE:
                return <DateTime />;
            case appointmentSteps.SELECT_PATIENT:
                return <SelectPatient />;
            case appointmentSteps.PAYMENT_CONFIRMATION:
                return <PaymentConfirmation />;
            default:
                return <SelectAppointment />;
        }
    }, [currentStep]);
    // Combined validation schema; only mounted fields validate due to shouldUnregister

    return (
        <>
            <Script
                src="https://checkout.razorpay.com/v2/checkout.js"
                strategy="lazyOnload"
                defer
            />
            <div className="bg-gray-100">
                <div className="relative w-full overflow-hidden">
                    <video
                        src="/images/pet_ct_scan.mp4"
                        poster="/images/pet_ct_scan.jpg"
                        autoPlay
                        muted
                        playsInline
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                </div>

                <div className="max-w-4xl mx-auto px-3 md:px-0 md:pb-16 pb-6">
                    <Header />
                    {DynamicComponent}
                </div>
            </div>
        </>
    );
}

export default PetCtAppointmentNew;

// export async function getServerSideProps() {
//     return {
//         redirect: {
//             destination: "/",
//             permanent: false,
//         },
//     };
// }
